import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'nx-ng-ticket-option',
  templateUrl: './ticket-option.component.html',
  styleUrls: ['./ticket-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketOptionComponent {
  @Input()
  banner?: string;

  @Input()
  title = '';

  @Input()
  subtitle?: string;

  @Input()
  fullPrice = 0;

  @Input()
  dailyPrice?: number;

  @Input()
  count = 0;

  @Input()
  flexible = false;

  @Input()
  id = '';

  @Output()
  ticketQuantity: EventEmitter<number> = new EventEmitter<number>();

  handleQuantityUpdated(quantity: number): void {
    this.ticketQuantity.emit(quantity);
  }
}
